export interface IPendingCommonSession {
  sessionId: string;
  tenantId: number;
  locationId: number;
  departmentId: number;
  createdAt: number;
  ttlMinutes: number;
}

export interface IGuestValidationSession {
  tenantId: number;
  locationId: number;
  tableId: number;
  contact?: string;
  mobileDigits?: string;
  verifiedAt: number;
  ttlMinutes: number;
}
